export default {
  navigationBarTitleText: intl.get('padLogin.title')
};
